import { render, staticRenderFns } from "./VentasListaCarrito.vue?vue&type=template&id=9b847474&"
import script from "./VentasListaCarrito.vue?vue&type=script&lang=js&"
export * from "./VentasListaCarrito.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports